import { IPromise } from "angular";
import { ApiResponse } from "../../AngularJS/Models/api-response.model";

export interface AttributeCategoryInfo {
    MaxSelectableCategories: number;
    AttributeCategoryModels: AttributeCategoryModel[];
}

export interface AttributeCategoryModel {
    CategoryID: number;
    CategoryName: string;

    // used for Data attributes only
    CategoryMask?: number;
    CategorySet?: number;
}

export interface AttributeValueModel {
    ID: number;
    Name: string;
}

export interface SelectedCategoryModel {
    SelectedCategoryID: number;
    SelectedAttributeIDs: number[];

    // used for Data attributes only
    CategoryMask?: number;
    CategorySet?: number;
}

export interface AttributeSelectorModel {
    Type: AttributeType;
    GroupedCategoryID?: number;
    SelectedCategories: SelectedCategoryModel[];
}

export class AttributeCategoryCacheItem {
    CachedCategories: AttributeCategoryInfo = null;
    CategoryCacheTime: number = null;
    CategoryCachePromise: IPromise<ApiResponse<AttributeCategoryInfo>> = null;
}

export class AttributeValueCacheInformation {
    CachePromise: IPromise<ApiResponse<AttributeValueModel[]>> = null;
    CacheTime: number = null;
}

export enum AttributeType {
    Data = 0,
    User = 1,
}
